import * as React from "react";
import { API, graphqlOperation } from "aws-amplify";
import { listShowBoothItems } from "graphql/queries";
import BoatMap from "components/molecures/BoatMap";
import { navigate } from "gatsby";
type Props = {
  show: any;
};

export default function BoothSelect(props: Props) {
  const { show } = props;
  const [data, setData] = React.useState<any[]>();

  React.useEffect(() => {
    async function f() {
      const res = await API.graphql(
        // @ts-ignore
        graphqlOperation(listShowBoothItems, {
          filter: {
            showID: { eq: show.showID },
          },
        })
      );
      // @ts-ignore
      const sortedItems = res.data.listShowBoothItems.items.sort((a, b) => {
        if (a.mapPriority && b.mapPriority) {
          return b.mapPriority - a.mapPriority;
        } else if (a.mapPriority && !b.mapPriority) {
          return -1;
        } else if (!a.mapPriority && b.mapPriority) {
          return 1;
        } else {
          return 0;
        }
      });
      const filtered = sortedItems.filter((item: any) => !!item.mapIcon);
      if (filtered.length % 2) {
        filtered.push({ mapIcon: { url: "" } });
      }
      setData(filtered);
    }
    f();
  }, [show.showID]);
  return <>{data && <BoatMap boothItems={data} show={show} />}</>;
}
